export const transformFormDietPlanForPdf = (
  dietPlanData: any,
  dietPlanId?: string,
) => ({
  plan_name: dietPlanData.diet_name,
  patient_id: dietPlanData.patient_id,
  start_date: dietPlanData.start_date,
  end_date: dietPlanData.end_date,
  total_calories: dietPlanData.calories,
  diet_plans_id: dietPlanId || dietPlanData.diet_plan_id,
  diet_plan_meal_rel: (dietPlanData.meals || [])
    .filter((meal: any) => meal.is_hidden !== "Y")
    .map((meal: any) => ({
      meal_type: meal.meal_name,
      hide_meal: meal.is_hidden || "N",
      start_time: meal.start_time,
      end_time: meal.end_time,
      meal_options: (meal.options || [])
        .filter((option: any) =>
          (option.food_items || []).some(
            (item: any) =>
              item.food_item_name &&
              item.food_item_name !== "" &&
              item.is_deleted !== "Y",
          ),
        )
        .map((option: any, idx: number) => ({
          option_no:
            option.order_no || option.options_name?.split(" ")?.[1] || idx + 1,
          option_data: (option.food_items || [])
            .filter(
              (item: any) =>
                item.food_item_name &&
                item.food_item_name !== "" &&
                item.is_deleted !== "Y",
            )
            .map((item: any) => ({
              food_name: item.food_item_name,
              quantity: item.quantity,
              unit_option_name: item.measure_name,
              tips: option.tips || "",
            })),
        })),
    })),
});
